/**
 * 商城公共上下文：productId(产品线) 与 saleOrgId(销售机构)
 * - 优先从当前 URL query 读取
 * - 其次从 sessionStorage 读取
 * - 读到后回写 sessionStorage，保证下单时不丢
 * 调用：const { productId, saleOrgId } = restoreMallCtx(this.$route)
 */
const PID_KEY = 'mall_product_id'
const OID_KEY = 'mall_sale_org_id'

export function restoreMallCtx(route) {
  const q = (route && route.query) || {}
  let productId = q.productId || sessionStorage.getItem(PID_KEY) || null
  let saleOrgId = q.saleOrgId || sessionStorage.getItem(OID_KEY) || null
  if (productId) sessionStorage.setItem(PID_KEY, productId)
  if (saleOrgId) sessionStorage.setItem(OID_KEY, saleOrgId)
  return { productId, saleOrgId }
}

export function getProductId() {
  return sessionStorage.getItem(PID_KEY)
}

export function getSaleOrgId() {
  return sessionStorage.getItem(OID_KEY)
}

/** 构造带商城上下文的 query 对象，供路由跳转使用 */
export function withCtx(extra) {
  const q = Object.assign({}, extra || {})
  const pid = getProductId()
  const oid = getSaleOrgId()
  if (pid) q.productId = pid
  if (oid) q.saleOrgId = oid
  return q
}
